import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

// Components
import SideMenu from "./SideMenu";

// Context
import { ConferencesContext } from "../../context/conferences";

const SideMenuContainer = (props) => {
    const { setIsSideMenuActive } = props;

    /**
     * Router Hooks
     */

    const history = useHistory();
    const location = useLocation();

    /**
     * useContext
     */

    const { featuredConference } = useContext(ConferencesContext);

    /**
     * useState
     */

    const [previousPathname, setPreviousPathname] = useState(location.pathname);

    /**
     * useEffect
     */

    useEffect(() => {
        if (location.pathname !== previousPathname) {
            setPreviousPathname(location.pathname);
            setIsSideMenuActive(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    /**
     * End Hooks
     */

    function goToHomepage() {
        history.push("/");
        setIsSideMenuActive(false);
    }

    function goToConference({ scrollToRegister }) {
        const registerQuery = scrollToRegister ? "?scroll=register" : "";
        history.push(`/conferences/${featuredConference.slug}${registerQuery}`);
    }

    function goToConferences() {
        const path = window.location.pathname;

        if (path === "/") {
            const element = document.getElementById('recent_conferences');
            element.scrollIntoView({ behavior: 'smooth' });
            console.log(element);
            console.log(path);
            console.log("homepage");
        }
        else {
            history.push("/");
            setTimeout(() => {
              const element = document.getElementById('recent_conferences');
              console.log(element);
              element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
            console.log(path);
            console.log("not homepage");
        }
        setIsSideMenuActive(false);
    }

    function goToVideos() {
        const path = window.location.pathname;
        if (path !== "/videos") {
            history.push("/videos");
        }
        setIsSideMenuActive(false);
    }

    return (
        <SideMenu
            {...props}
            goToHomepage={goToHomepage}
            goToConference={goToConference}
            goToConferences={goToConferences}
            goToVideos={goToVideos}
        />
    );
};

export default SideMenuContainer;
